import WhiteSpinner from "./white-spinner.jsx";

export const CustomButton = ({
	children,
	loading,
	theme = "primary",
	variant = "solid",
	size = "normal",
	className = "",
	...rest
}) => {
	function themeStyle() {
		const outlinedClasses =
			"text-primary outline outline-1 outline-primary hover:bg-secondary/10";
		const dangerClasses =
			"text-red-500 outline outline-1 outline-red-500 hover:bg-red-500/10";
		const solidClasses =
			"text-white bg-primary outline outline-1 outline-primary dark:outline-darkPrimary";
		return variant === "solid"
			? solidClasses
			: variant === "danger"
				? dangerClasses
				: outlinedClasses;
	}

	function handleSize(size) {
		if (size === "small") {
			return "p-2 text-sm";
		}
		return "p-3 text-[14px]";
	}

	return (
		<button
			className={`w-full ${handleSize(
				size
			)} rounded-[10px] hover:opacity-80 h-[50px] text-[14px] font-[600] flex items-center justify-center gap-1 disabled:bg-gray-400 disabled:outline-gray-600 disabled:outline-2 ${themeStyle(
				theme
			)} ${className}`}
			{...rest}
			disabled={loading || rest.disabled}
		>
			{loading ? <WhiteSpinner /> : children}
		</button>
	);
};
